import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import ProductItem from '../ProductItem';
import { IProduct } from '@/tpss/types';

interface ProductGroupProps {
  products: IProduct[];
}

const ProductGroup: React.FC<ProductGroupProps> = ({ products }) => {
  const [productList, setProductList] = useState<IProduct[]>([]);

  useEffect(() => {
    console.log('ProductGroup', products);
    setProductList(products);
  }, [products]);

  return (
    <div className={styles.productSetContainer}>
      {productList?.length > 0 && (
        <div className={styles.productSet}>
          {productList?.map((prod, index) => (
            <ProductItem key={prod.ID} product={prod} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductGroup;
